import { api, apiComm } from "./api-core";

export interface IHost {
  host_name: string;
  host_email: string;
  host_organization?: string;
  host_bio?: string;
}

export interface IWorkshopForm {
  id?: any;
  title: string;
  description: string;
  learning_objective: any;
  target_audience: any;
  host_type: any;
  hosts: IHost[]; 
  duration: any;
  format: any;
  category_id: any;
  max_attendee: any;
  image: File | string | null;
  date: string;
  event_link: string;
  video_link: string;
  discussion_link: string;
  created_by: string;
  is_public: any;
  is_featured: any;
  topics: {
    id: number;
    name: string;
  }[];
  attached_documents: any[];
  status: any;
}

export interface IWorkshopFormEdit {
  id: any;
  title: any;
  description: any;
  learning_objectives: any;
  target_audience: any;
  host_type: any; // Default to pythaverse
  host_name: any;
  host_email: any;
  host_organization: any; // Change to null to match API if it can be null
  host_bio_snippet: any; // Add this if it exists in your API response and you plan to use it
  hosts: IHost[]; 
  date: any;
  duration: any; // Changed to number based on API data
  format: any;
  category: any; // Or a default category ID if applicable
  max_attendee: any; // Changed to number based on API data
  event_link: any;
  topic: {
    id: number;
    name: string;
  }[]; // Khởi tạo topic là một mảng rỗng với kiểu Topic[]
  image_url: any;
  resources: any;
  video_recording_url: any;
  discussion_link: any;
  course_url: any;
  status: any;
  is_featured: any;
  is_public: any;
  created_by: any;
  created_at: any;
  updated_at: any;
  image_url_old: any;
  attached_documents: any[];
}

export interface Topics {
  id: string;
  name: string;
  description?: string;
  status?: string;
  created_at?: string;
  updated_at?: string;
}

export interface IWorkshopDetail {
  id: string;
  title: string;
  description: string;
  image_url: string;
  date: string;
  event_link: string;
  video_link: string;
  discussion_link: string;
  created_by: string;
  host: string;
  is_featured: string;
  is_public: string;
  created_at: string;
  updated_at: string;
  topics: Topics[];
}

export interface IWorkshop {
  status: boolean;
  code: string;
  data: {
    id: string;
    title: string;
    description: string;
    image_url: string;
    date: string;
    event_link: string;
    video_link: string;
    created_by: string;
    host: string;
    is_featured: string;
    is_public: string;
    created_at: string;
    updated_at: string;
    topics: Topics[];
  }[];
  total: number;
}

export interface IWorkshopProposalForm {
  id?: any;
  title: string;
  description: string;
  username: any;
  user_fullname: any;
  user_email: any;
  learning_objectives?: any;
  image: File | string | null;
  date?: any;
  duration: any;
  category_id: any;
  max_attendee: any;
  format: any;
  target_audience: any;
  event_link: any;
  topics: {
    id: number;
    name: string;
  }[];
}

export interface IProposalFormEdit {
  id: number;
  title: string;
  description: string;
  username: string;
  user_fullname: string;
  user_email: string;
  learning_objectives: string;
  date: string;
  format: string;
  target_audience: string;
  duration: number;
  category_id: number;
  max_attendee: number;
  image_url: string | null;
  event_link: string;
  topics: {
    id: any;
    name: any;
  }[];
  status: string; // The status field is crucial here
  reviewed_by: string | null;
  reviewed_at: string | null;
  admin_notes: string | null; // Admin notes for rejection
  approved_workshop_id: number | null;
  created_at: string;
  updated_at: string;
  image_url_old: string | null;
  current_user: any
}

export const WorkshopApi = {
  getListWorkshop: (
    page?: any,
    per_page?: any,
    searchTerm?: string,
    category_id?: any,
    status_type?: any,
    workshop_status?: any,
    username?: any,
    is_my_workshop?: boolean, // Thêm tham số cho "My workshops"
    is_registered_workshop?: boolean,
    userTimeZone?: any
  ) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (category_id) params.append("category_id", category_id);
    if (status_type) params.append("status_type", status_type);
    if (workshop_status) params.append("workshop_status", workshop_status);
    if (username) params.append("username", username);
    if (userTimeZone) params.append("userTimeZone", userTimeZone);

    if (is_my_workshop) params.append("is_my_workshop", "true");
    if (is_registered_workshop) params.append("is_registered_workshop", "true");

    const url = `${process.env.API_GET_LIST_WORKSHOP}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getListTopic: () => {
    return api
      .get(process.env.API_GET_LIST_TOPIC as string)
      .then((res) => {
        return res.data.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  changeStatusPublic: (data: { id: number; is_public: number }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_CHANGE_PUBLIC;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  createWorkshop: (data: IWorkshopForm) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "image") {
          // Kiểm tra xem 'value' có phải là một File hay Blob không
          // Dùng 'instanceof' là cách tốt nhất để kiểm tra type của File
          // if (value instanceof File) {
          //     formData.append(key, value);
          // }
          formData.append(key, value);
          // Nếu không phải là File, có thể là string (URL ảnh) hoặc null,
          // thì không cần thêm vào formData nếu không có giá trị
          return;
        }

        if(key == 'attached_documents'){
          console.log(123, value)
          value.forEach((item: any, index: any) => {
            formData.append(`${key}[]`, item);
          });
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_CREATE_WORKSHOP;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
  updateWorkshop: (data: FormData) => {
    // const formData = new FormData();
    // // Duyệt qua tất cả các trường trong data và thêm vào formData
    // Object.entries(data).forEach(([key, value]) => {
    //   if (value !== undefined && value !== null) {
    //     if (key === "image_url") {
    //       // Kiểm tra xem 'value' có phải là một File hay Blob không
    //       // Dùng 'instanceof' là cách tốt nhất để kiểm tra type của File
    //       // if (value instanceof File) {
    //       //     formData.append(key, value);
    //       // }
    //       formData.append(key, value);
    //       // Nếu không phải là File, có thể là string (URL ảnh) hoặc null,
    //       // thì không cần thêm vào formData nếu không có giá trị
    //       return;
    //     }

    //     if (Array.isArray(value)) {
    //       value.forEach((item, index) => {
    //         if (typeof item === "object") {
    //           // Duyệt từng field của object trong mảng
    //           Object.entries(item).forEach(([subKey, subValue]) => {
    //             if (subValue !== undefined && subValue !== null) {
    //               formData.append(
    //                 `${key}[${index}][${subKey}]`,
    //                 subValue.toString()
    //               );
    //             }
    //           });
    //         } else {
    //           formData.append(`${key}[${index}]`, item.toString());
    //         }
    //       });
    //     } else if (typeof value === "object") {
    //       // Nếu là object, stringify toàn bộ (nếu cần)
    //       formData.append(key, JSON.stringify(value));
    //     } else {
    //       // Nếu là giá trị đơn giản, thêm vào bình thường
    //       formData.append(key, value.toString());
    //     }
    //   }
    // });

    const url = process.env.API_UPDATE_WORKSHOP;

    return api
      .post(url as string, data, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  deleteWorkshop: (data: { id: number }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          // Xử lý trường hợp là mảng
          value.forEach((item) => {
            formData.append(`${key}[]`, item.toString());
          });
        } else if (typeof value === "object" && !Array.isArray(value)) {
          // Xử lý trường hợp là đối tượng (ví dụ: parent)
          Object.entries(value).forEach(([subKey, subValue]) => {
            if (subValue !== undefined && subValue !== null) {
              // Sử dụng cú pháp đúng cho FormData
              formData.append(`${key}[${subKey}]`, subValue.toString());
            }
          });
        } else {
          // Xử lý các trường đơn
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_DELETE_WORKSHOP;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getNearestWorkshop: (username?: any, userTimeZone?: any) => {
    const params = new URLSearchParams();
    if (username) params.append("username", username);
    if (userTimeZone) params.append("userTimeZone", userTimeZone);

    const url = `${process.env.API_GET_NEAREST_WORKSHOP}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getUserRegisteredWorkshop: (username?: any) => {
    const params = new URLSearchParams();
    if (username) params.append("username", username);

    const url = `${
      process.env.API_GET_USER_REGISTERED_WORKSHOP
    }?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  registerWorkshop: (data: {
    username?: any;
    workshop_id?: any;
    user_email?: any;
    userTimeZone?: any;
  }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_REGISTER_WORKSHOP;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getRecentCommunity: (page?: any, per_page?: any) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);

    const url = `${process.env.API_GET_RECENT_TOPIC}?${params.toString()}`;
    return apiComm
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getUpcomingWorkshop: (
    userTimeZone?: any
  ) => {
    const params = new URLSearchParams();
    if (userTimeZone) params.append("userTimeZone", userTimeZone);

    const url = `${process.env.API_GET_UPCOMING_WORKSHOP}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getPastWorkshop: (
    username?: any,
    page?: any,
    per_page?: any,
    searchTerm?: string
  ) => {
    const params = new URLSearchParams();
    if (username) params.append("username", username);
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);
    if (searchTerm) params.append("searchTerm", searchTerm);

    const url = `${process.env.API_GET_PAST_WORKSHOP}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  generateSummary: (data: { title?: any; brief_summary?: any }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_GENERATE_SUMMARY;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  generateLearningObjective: (data: { title?: any; summary?: any; learning_objectives?: any }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_GENERATE_LEARNING_OBJECTIVE;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  generateImage: (data: { prompt?: any }) => {
    const formData = new FormData();

    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });
    const url = process.env.API_GENERATE_IMAGE;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getListEducator: (searchTerm?: string) => {
    const params = new URLSearchParams();
    if (searchTerm) params.append("searchTerm", searchTerm);

    const url = `${process.env.API_LIST_EDUCATOR}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },
  getListCategory: () => {
    const params = new URLSearchParams();

    const url = `${
      process.env.API_LIST_WORKSHOP_CATEGORY
    }?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  createWorkshopProposal: (data: IWorkshopProposalForm) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "image") {
          // Kiểm tra xem 'value' có phải là một File hay Blob không
          // Dùng 'instanceof' là cách tốt nhất để kiểm tra type của File
          // if (value instanceof File) {
          //     formData.append(key, value);
          // }
          formData.append(key, value);
          // Nếu không phải là File, có thể là string (URL ảnh) hoặc null,
          // thì không cần thêm vào formData nếu không có giá trị
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_CREATE_PROPOSAL;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },

  getWorkshopById: (id?: any, username?: any, userTimeZone?: any) => {
    const params = new URLSearchParams();
    if (id) params.append("id", id);
    if (username) params.append("username", username);
    if (userTimeZone) params.append("userTimeZone", userTimeZone);
    const url = `${process.env.API_GET_WORKSHOP_BY_ID}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getListWorkshopProposal: (
    page?: any,
    per_page?: any,
    searchTerm?: string,
    category_id?: any,
    proposal_status?: any,
    username?: any
  ) => {
    const params = new URLSearchParams();
    if (page) params.append("page", page);
    if (per_page) params.append("per_page", per_page);
    if (searchTerm) params.append("searchTerm", searchTerm);
    if (category_id) params.append("category_id", category_id);
    if (proposal_status) params.append("proposal_status", proposal_status);
    if (username) params.append("username", username);

    const url = `${process.env.API_GET_LIST_PROPOSAL}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  getProposalById: (id?: any, username?: any) => {
    const params = new URLSearchParams();
    if (id) params.append("id", id);
    if (username) params.append("username", username);
    const url = `${process.env.API_GET_PROPOSAL_BY_ID}?${params.toString()}`;
    return api
      .get(url as string)
      .then((res) => {
        return res.data || [];
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  },

  updateProposal: (data: IProposalFormEdit) => {
    const formData = new FormData();
    // Duyệt qua tất cả các trường trong data và thêm vào formData
    Object.entries(data).forEach(([key, value]) => {
      if (value !== undefined && value !== null) {
        if (key === "image_url") {
          // Kiểm tra xem 'value' có phải là một File hay Blob không
          // Dùng 'instanceof' là cách tốt nhất để kiểm tra type của File
          // if (value instanceof File) {
          //     formData.append(key, value);
          // }
          formData.append(key, value);
          // Nếu không phải là File, có thể là string (URL ảnh) hoặc null,
          // thì không cần thêm vào formData nếu không có giá trị
          return;
        }

        if (Array.isArray(value)) {
          value.forEach((item, index) => {
            if (typeof item === "object") {
              // Duyệt từng field của object trong mảng
              Object.entries(item).forEach(([subKey, subValue]) => {
                if (subValue !== undefined && subValue !== null) {
                  formData.append(
                    `${key}[${index}][${subKey}]`,
                    subValue.toString()
                  );
                }
              });
            } else {
              formData.append(`${key}[${index}]`, item.toString());
            }
          });
        } else if (typeof value === "object") {
          // Nếu là object, stringify toàn bộ (nếu cần)
          formData.append(key, JSON.stringify(value));
        } else {
          // Nếu là giá trị đơn giản, thêm vào bình thường
          formData.append(key, value.toString());
        }
      }
    });

    const url = process.env.API_UPDATE_PROPOSAL;

    return api
      .post(url as string, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      })
      .then((res) => res.data)
      .catch((err) => {
        console.error("Error:", err);
        throw err; // Ném lỗi để xử lý ở nơi gọi hàm
      });
  },
};
